import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiserviceService } from 'src/app/services/apiservice.service';

@Component({
  selector: 'app-carpeta',
  templateUrl: './carpeta.page.html',
  styleUrls: ['./carpeta.page.scss'],
})
export class CarpetaPage implements OnInit {

  @Input()  folder
  descripcion='';

  constructor(  public apiservice: ApiserviceService,
    private modalCtrl:  ModalController) { }

  ngOnInit() {

    console.log(this.folder);
  }
 
  async crear(){

    if(this.descripcion.length==0){
      this.apiservice.mensaje('Falta descripcion','danger');
    }
    else{

      
    var result = await this.apiservice.postapi2car(JSON.stringify({'carpeta':this.folder.url,'nombre':this.descripcion})); //

    if(result['estado']==1){
      this.apiservice.mensaje('Creando...','success');
    //////////////////////////////////////////////////////
    this.modalCtrl.dismiss([{
      'estado':false,
      'name':this.descripcion,
      'subfolders':[],
      'tipo':'0',
      'aux':'0',
      'url':this.folder.url+this.descripcion,
      'visible':true
          }]);
    /////////////////////////////////////////////////////
        }
   else{
    this.apiservice.mensaje(result['mensaje'],'danger');
   }
      console.log(this.folder);
    }
  }

  regresar(){

this.modalCtrl.dismiss([]);
    
  }

}
